import { sampleSize } from 'lodash'
import { mergeArrays, shuffleArray } from '../lib/helpers/array'
import { getRandomElementFromArray } from '../lib/helpers/common'

export const SET_ICONS = 'SET_ICONS'
export const SET_DEFAULT_ICONS = 'SET_DEFAULT_ICONS'
export const CLEAR_ICONS = 'CLEAR_ICONS'
export const ADD_ICONS = 'ADD_ICONS'
export const INCR_ICON_PAGE = 'INCR_ICON_PAGE'
export const SET_ICON_PAGE = 'SET_ICON_PAGE'

export const state = () => ({
  icons: [],
  default_icons: [],
  icon_page: 0,
})

export const mutations = {
  [SET_ICONS](state, icons) {
    state.icons = icons
  },
  [SET_DEFAULT_ICONS](state, icons) {
    state.default_icons = icons
  },
  [ADD_ICONS](state, icons) {
    if (Array.isArray(icons)) {
      state.icons.push(...icons)
    } else {
      state.icons.push(icons)
    }
  },
  [SET_ICON_PAGE](state, value) {
    state.icon_page = value
  },
  [INCR_ICON_PAGE](state) {
    if (state.icon_page === 15) {
      state.icon_page = 0
    } else {
      state.icon_page++
    }
  },
}

export const actions = {
  async randomDefaultIcon({ state }) {
    return getRandomElementFromArray(state.default_icons)
  },
  async getIcon({ commit }, id) {
    const response = await this.$api.get(`/api/v3/assets/icons/${id}`)
    const icon = response.data
    commit(ADD_ICONS, icon)
    return icon
  },
  async getIcons({ state, commit, rootState, rootGetters, dispatch }) {
    const selected_icons = rootState.editor.selected_icons
    if (selected_icons.length > 0) {
      return selected_icons
    }

    let keywords = [...rootGetters['session/getKeywords']]
    if (keywords.length === 0) keywords.push('abstract')
    if (keywords.length > 3) keywords = sampleSize(keywords, 3)
    const quantity = Math.floor(20 / keywords.length)
    let icons = await dispatch('getIconsForKeywords', { keywords, quantity })

    if (icons.length === 0) {
      icons = await dispatch('getIconsForKeywords', {
        keywords: ['abstract', 'shape'],
        quantity: 10,
      })
    }

    if (state.default_icons.length === 0 && rootState.flags.default_icon_set) {
      try {
        const default_icons = await dispatch('getDefaultIconSet')
        commit(SET_DEFAULT_ICONS, default_icons)
      } catch {}
    }

    shuffleArray(icons)
    commit(ADD_ICONS, icons)
    if (state.icon_page === 10) commit('icons/SET_ICON_PAGE', 0)
    return icons
  },

  async getDefaultIconSet() {
    const response = await this.$api.get('/api/v3/assets/icons/ideas')
    return response.data
  },
  // eslint-disable-next-line no-empty-pattern
  async getIconsForKeyword({ state }, args) {
    const { query, quantity } = args
    try {
      const response = await this.$api.get(`/api/v3/assets/icons`, {
        params: {
          keywords: [query],
          quantity,
          page: state.icon_page,
          set: 'nounproject',
        },
      })
      const icons = response.data
      return icons
    } catch (error) {
      console.log('error', error)
      return []
    }
  },
  async getIconsForKeywords({ dispatch }, args) {
    const { keywords, quantity } = args
    const promises = keywords.map(key =>
      dispatch('getIconsForKeyword', { query: key, quantity })
    )
    const results = await Promise.all(promises)
    return mergeArrays(results)
  },
}
